import { registerPlugin } from '@capacitor/core';
const AppLanguage = registerPlugin('AppLanguage', {
    web: () => import('./web').then((m) => new m.AppLanguageWeb()),
});
export * from './definitions';
export { AppLanguage };
//# sourceMappingURL=index.js.map